import { Button } from '@mui/material';
import { useMemo } from 'react';
import Translate from '@/component/Translate';
import { getBreachBaseSignalName } from '@/feature/alarm/utils';
import { useTexts } from '@/feature/lang';
import { useSignalMetadataQuery } from '@/feature/signals/useSignalMetadataQuery';
import { Icon } from '@/icon/Icon';
import { useSignalTrendNavigation } from '@/view/fleet/navigation/useSignalTrendNavigation';
import type { Alarm } from '../types';

interface ViewSignalTrendButtonProps {
  alarm: Alarm | undefined;
}

const TWELVE_HOURS_MS = 60 * 60 * 1000 * 12;

export const ViewSignalTrendButton = ({
  alarm,
}: ViewSignalTrendButtonProps) => {
  const texts = useTexts().fleet.alarms;
  const { data: metadata } = useSignalMetadataQuery(alarm?.equipmentId);
  const baseSignalName = getBreachBaseSignalName(alarm, metadata);
  const navigate = useSignalTrendNavigation(alarm?.equipmentId, baseSignalName);

  const dateRange = useMemo(() => {
    if (!alarm?.eventTriggered) {
      return undefined;
    }
    const triggered = new Date(alarm.eventTriggered);
    return {
      from: new Date(triggered.getTime() - TWELVE_HOURS_MS),
      to: new Date(triggered.getTime() + TWELVE_HOURS_MS),
    };
  }, [alarm]);

  if (!navigate) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      onClick={() => navigate(dateRange)}
      color="inherit"
      startIcon={<Icon name="show_chart" />}
    >
      <Translate text={texts.details.viewSignalTrend} />
    </Button>
  );
};
